enum ChangeTypeEnum 
{
    DeliverToSafePlace,
    DeliverToNeighbour,
    DeliverToServiceLocation,
    UpdateIntendedDate,
    Cancel
};

export default ChangeTypeEnum;